import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import appReducer from './reducers/appSlice';
import authReducer from './reducers/authSlice';
import driverManagementReducer from './reducers/driverManagementSlice';
import preRegistrationManagementReducer from './reducers/preRegistrationSlice';
import tabReducer from './reducers/tabSlice';
import facilityReducer from './reducers/facilitySlice';
import notificationReducer from './reducers/notificationSlice';

const persistConfig = {
  key: 'auth',
  storage,
  whitelist: ['jwtAccessToken', 'jwtRefreshToken', 'user', 'config'],
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);

export const store = configureStore({
  reducer: {
    app: appReducer,
    auth: persistedAuthReducer,
    driverManagement: driverManagementReducer,
    preRegistrationManagement: preRegistrationManagementReducer,
    tab: tabReducer,
    facility: facilityReducer,
    notificationList: notificationReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
